import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Brands from './components/Brands';
import Products from './components/Products';
import WhyUs from './components/WhyUs';
import Shipping from './components/Shipping';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';

export default function HomePage() {
  return (
    <div className="bg-[#0d0d0d] min-h-screen">
      <Navbar />
      <Hero />
      <Brands />
      <Products />
      <WhyUs />
      <Shipping />
      <Gallery />
      <Testimonials />
      <Contact />
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
